/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Builds the API payload for registration event create/update submissions.
 * @module utils/eventCreation/eventCreationSubmitPayload
 */

import dayjs from "dayjs";

export const buildEventCreationSubmitPayload = ({
  formData,
  imageChanged,
  imageName,
  imageFormat,
  emailRequired,
  userId,
}) => ({
  ...formData,
  nombreImagen: imageChanged ? imageName : null,
  formatoImagen: imageChanged ? imageFormat : null,
  correoRequerido: emailRequired,
  userId,
  fechaEvento: dayjs(formData.fechaEvento).format("YYYY-MM-DD"),
  fechaDisponibleSocios: formData.fechaDisponibleSocios
    ? dayjs(formData.fechaDisponibleSocios)
        .hour(0)
        .minute(0)
        .second(0)
        .utc("z")
        .toISOString()
    : null,
  fechaDisponibleNoSocios: formData.fechaDisponibleNoSocios
    ? dayjs(formData.fechaDisponibleNoSocios)
        .hour(0)
        .minute(0)
        .second(0)
        .utc("z")
        .toISOString()
    : null,
  fechaLimiteRegistro: formData.fechaLimiteRegistro
    ? dayjs(formData.fechaLimiteRegistro)
        .hour(23)
        .minute(59)
        .second(59)
        .utc("z")
        .toISOString()
    : null,
  fechaDeCreacion: formData.fechaDeCreacion || dayjs().utc("z").toISOString(),
});
